import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import _isString from 'lodash-es/isString';

import { DateService } from "./date.service";
import { LanguageService } from "libraries/service/language/language.service";

/**
 * Use Moment.js to display date
 * Reason : angular2 moment.js has errors in IE or FF
 * Reason2: We have to display UTC format, not browser local
 */
@Pipe({ name: 'dateMoment' })
export class DateMomentPipe implements PipeTransform {

    public static readonly ISO_DATE_FORMAT: string = 'YYYY-MM-DD';
    public static readonly TIME_FORMAT: string = "HH:mm";
    public static readonly TIME_FORMAT_OFFSET: string = "HH:mm Z";

    constructor(private readonly dateService: DateService,
                private readonly languageService: LanguageService){}

    /**
     * * "time": "HH:mm"
     * * "momentMedium":"ddd DD MMM YYYY",
     * * "momentShort":"DD/MM/YYYY"
     */
    public transform(date: string | Date, dateFormat: string, showTime?: boolean, showOffset?: boolean): string {
        const language: string = this.languageService.userLanguage;
        //#31738 - Issue on DOB on SKN, gave format MM/DD/YYYY
        moment.locale(language);

        //§TODO : store offset for future display
        //moment.parseZone(date).utcOffset(); for date offset
        //moment(date).utcOffset(); for client offset
        if(_isString(date)){
            const tempDate: string = this.dateService.removeOffset(date);

            const dateOutput: moment.Moment = moment.utc(tempDate);
            if(tempDate.includes('T') && showTime){
                if(showOffset){
                    const outputDatePart: string = moment(date).parseZone().format(dateFormat || "LL");
                    const time: string = moment(date).parseZone().format(DateMomentPipe.TIME_FORMAT_OFFSET);
                    return `${outputDatePart} ${time} `;
                }
                const outputDatePart: string = moment(date).parseZone().format(dateFormat || "LL");
                const time: string = moment(date).parseZone().format(DateMomentPipe.TIME_FORMAT);
                return `${outputDatePart} ${time} `;
            }
            return dateOutput.format(dateFormat || "LL");
        }

        return moment(date).format(dateFormat);
    }
}
